module.exports = __webpack_public_path__ + "static/Scope 5-f84c1c7769b0e5f7277d2137bf1ae7ac.jpg";